import { render, staticRenderFns } from "./PlotEditPage.vue?vue&type=template&id=5af24c3b&"
import script from "./PlotEditPage.vue?vue&type=script&lang=ts&"
export * from "./PlotEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports